/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Input, Modal, Select, Spin } from 'antd';
import MenuActions from '../../redux/middleware/menu';
import './style.scss';
import Utils from '../../redux/utils';
import { handleFloat, formatNumberFloatValue } from '../../helper/sortData';
type Props = {
  handleDialog: any;
  open: boolean;
  modalData: any;
  selectedVariation?: any;
  onSubmit?: any;
};

const MenuModal = (props: Props) => {
  const user = Utils.getCurrentUser();
  const brand = Utils.getCurrentBrand();
  let { handleDialog, open, modalData, selectedVariation, onSubmit } = props;
  const [blocked] = useState(true);
  const [disable] = useState(true);
  const [loader, setLoader] = useState(false);
  const [Profitability, setProfibility] = useState<any>(
    modalData?.final_price !== 0
      ? ((modalData?.final_price / (1 + user?.country_vat / 100) -
          modalData?.total_cost) /
          (modalData?.final_price / (1 + user?.country_vat / 100))) *
          100
      : 0
  );

  // const [Profitability, setProfibility] = useState<any>(
  //   modalData?.final_price !== 0
  //     ? ((modalData?.final_price - modalData?.total_cost) /
  //         modalData?.final_price) *
  //         100
  //     : 0
  // );
  const [suggestedPrice, setSuggestedPrice] = useState<any>();
  const [errorList, setErrorList] = useState<any>({});
  const [errorStatus, setErrorStatus] = React.useState(false);
  const [finalMenuPrice, setFinalMenuPrice] = useState<any>(
    modalData?.is_variation === 'yes'
      ? modalData?.variation_list[0]?.final_price
      : modalData?.final_price !== 0 && modalData?.final_price
  );
  const [selectedVariationIndex, setSelectedVariationIndex] = useState(
    modalData?.variationIndex || 0
  );

  // const array = [
  //   { value: 'Large', label: 'Large' },
  //   {
  //     value: 'Medium',
  //     label: 'Medium',
  //   },
  //   {
  //     value: 'Small',
  //     label: 'Small',
  //   },
  // ];

  useEffect(() => {
    handleSuggestedPrice();
  }, []);

  const handleSuggestedPrice = async () => {
    let suggestedprice = modalData?.total_cost / (brand?.cost_ratio / 100);
    suggestedprice += (suggestedprice * (user?.country_vat || 0)) / 100;
    setSuggestedPrice(brand?.cost_ratio ? suggestedprice : 0);
  };

  const handleChangeMenuPrice = async (e: any) => {
    setFinalMenuPrice(e.target.value);
    if (
      e.target.value != 0 &&
      e.target.value !== '' &&
      !isNaN(e.target.value)
    ) {
      // let profitibility =
      //   ((e.target.value - modalData?.total_cost) / e.target.value) * 100;

      const priceExcludingVAT = user?.country_vat
        ? e.target.value / (1 + user.country_vat / 100)
        : e.target.value;

      const profitibility =
        ((priceExcludingVAT - modalData?.total_cost) / priceExcludingVAT) * 100;
      setProfibility(profitibility);
    } else {
      setProfibility(0);
    }
  };

  const handleSubmit = async () => {
    setLoader(true);
    setErrorList({});
    setErrorStatus(false);
    const params = {
      fcr: modalData.fcr,
      menu_price: modalData.final_price || 0,
      propose_price: Number(+suggestedPrice.toString().replace(/,/g, '')),
      total_cost: modalData.total_cost,
      final_price: finalMenuPrice ? finalMenuPrice : '',
      profitability: Profitability,
      item_type: modalData.item_type,
    };

    const response = await MenuActions.updateManageMenu(
      modalData?.is_variation == 'yes'
        ? modalData?.variation_list[selectedVariationIndex]?.id
        : // ? modalData?.variation_list[modalData?.variationIndex ?? 0]?.id
          modalData?.id,
      params
    );
    if (response == undefined || !response?.success) {
      if (response != undefined) {
        setErrorList(response?.error);
        setErrorStatus(true);
      }
    } else {
      onSubmit();
    }
    setLoader(false);
  };

  // const handleVariationChange = (value: any) => {
  //   const selectedIndex = modalData?.variation_list.findIndex(
  //     (item: any) => item.variation === value
  //   );
  //   if (selectedIndex !== -1) {
  //     setSelectedVariationIndex(selectedIndex);
  //     setFinalMenuPrice(
  //       modalData?.variation_list[selectedIndex]?.final_price || ''
  //     );
  //     setProfibility(
  //       modalData?.variation_list[selectedIndex]?.final_price !== 0
  //         ? ((modalData?.variation_list[selectedIndex]?.final_price -
  //             modalData?.variation_list[selectedIndex]?.total_cost) /
  //             modalData?.variation_list[selectedIndex]?.final_price) *
  //             100
  //         : 0
  //     );
  //   }
  // };

  const handleVariationChange = (value: any) => {
    const selectedIndex = modalData?.variation_list.findIndex(
      (item: any) => item.variation === value
    );
    if (selectedIndex !== -1) {
      setSelectedVariationIndex(selectedIndex);
      const selectedVariation = modalData?.variation_list[selectedIndex];
      setFinalMenuPrice(selectedVariation?.final_price || '');
      setProfibility(
        selectedVariation?.final_price !== 0
          ? ((selectedVariation?.final_price / (1 + user?.country_vat / 100) -
              selectedVariation?.total_cost) /
              (selectedVariation?.final_price /
                (1 + user?.country_vat / 100))) *
              100
          : 0
      );
      // setProfibility(
      //   selectedVariation?.final_price !== 0
      //     ? ((selectedVariation?.final_price - selectedVariation?.total_cost) /
      //         selectedVariation?.final_price) *
      //         100
      //     : 0
      // );
      setSuggestedPrice(
        brand?.cost_ratio
          ? selectedVariation?.total_cost / (brand?.cost_ratio / 100)
          : 0
      );
    }
  };

  return (
    <Modal
      title={<div className="title font">Edit</div>}
      centered
      open={open}
      onCancel={handleDialog}
      width={608}
      footer={null}
    >
      <Spin spinning={loader} size="large" className="loaderWidthHeight">
        <div className="MenuModal">
          <div className="menuSubContainer ingredientSubContainermargin">
            <div className="ingredientLabel">Recipe Name</div>
            <Input
              placeholder="Input ingredient here"
              size="large"
              disabled={blocked}
              value={modalData?.recipe_name || modalData?.combo_name}
            />
          </div>
          {modalData?.is_variation == 'yes' && (
            <div className="menuSubContainer">
              <div className="ingredientLabel">Variation Name</div>
              <Select
                size={'large'}
                value={
                  modalData?.variation_list[selectedVariationIndex]
                    ?.variation || ''
                }
                // value={
                //   modalData?.variation_list[modalData?.variationIndex || 0]
                //     ?.variation
                //     ? modalData?.variation_list[modalData?.variationIndex || 0]
                //         ?.variation
                //     : ''
                // }
                placeholder="Select Variation"
                onChange={handleVariationChange}
                // disabled={blocked}
                // defaultValue={
                //   modalData?.variation_list[modalData?.variationIndex || 0]
                //     ?.variation
                //     ? modalData?.variation_list[modalData?.variationIndex || 0]
                //         ?.variation
                //     : ''
                // }
                options={modalData?.variation_list.map((item: any) => ({
                  label: item.variation,
                  value: item.variation,
                }))}
              />
            </div>
          )}

          <div className="menuSubContainer">
            <div className="row">
              <span className="col">
                <div className="wizardLabel">Cost</div>
                <span className="pricegroup">
                  <span>{brand?.currency_name}</span>
                  <div className={blocked ? 'disableDiv' : ''}>
                    {modalData?.is_variation == 'yes'
                      ? formatNumberFloatValue(
                          modalData?.variation_list[selectedVariationIndex]
                            ?.total_cost
                        )
                      : formatNumberFloatValue(modalData?.total_cost)}
                  </div>
                </span>
              </span>
              <span className="col">
                <div className="wizardLabel">Brand FCR %</div>
                <span className="pricegroup">
                  <div className={blocked ? 'disableDiv' : ''}>
                    {' '}
                    {Number(brand?.cost_ratio.toFixed(2))}
                  </div>
                  <span>%</span>
                </span>
              </span>
            </div>
          </div>
          <div className="menuSubContainer">
            <div className="row">
              <span className="col">
                <div className="wizardLabel">Suggested Price</div>
                <span className="pricegroup">
                  <span>{brand?.currency_name}</span>
                  <div className={blocked ? 'disableDiv' : ''}>
                    {suggestedPrice
                      ? formatNumberFloatValue(suggestedPrice)
                      : 0}
                  </div>
                </span>
              </span>
              <span className="col">
                <div className="wizardLabel">VAT %</div>
                <span className="pricegroup">
                  <div className={blocked ? 'disableDiv' : ''}>
                    {user?.country_vat.toFixed(2)}
                  </div>
                  <span>%</span>
                </span>
              </span>
            </div>
          </div>
          <div className="menuSubContainer">
            <div className="row">
              <span className="col">
                <div className="wizardLabel">
                  Final Menu Price (incl. Tax) <span className="sterik">*</span>
                </div>
                <span className="finalMenuPrice">
                  <Input
                    placeholder="0"
                    type="number"
                    value={finalMenuPrice}
                    disabled={modalData?.status === 1}
                    onChange={(e) => handleChangeMenuPrice(e)}
                    required
                    className={
                      errorList['final_price']?.length > 0 ? 'borderRed' : ''
                    }
                  />
                  {errorStatus && (
                    <div className="subRecipeErrorMessages">
                      {errorList['final_price']}
                    </div>
                  )}
                </span>
              </span>
              <span className="col">
                <div className="wizardLabel">Profitability %</div>
                <span className="pricegroup">
                  <div className={blocked ? 'disableDiv' : ''}>
                    {Profitability.toFixed(2)}
                  </div>
                  <span>%</span>
                </span>
                {/* <span className="pricegroup">
                <span>{brand?.currency_name}</span>
                <Input
                  type="number"
                  value={handleFloat(Profitability)}
                  disabled={blocked}
                />
              </span> */}
              </span>
            </div>
          </div>
          <div className="butonGroup">
            <div className="wizard-button" onClick={() => handleDialog({})}>
              Back
            </div>

            {/* <div
              className={`continue wizard-button ${
                +handleFloat(Profitability) < 0 && 'menu-disable-button'
              }`}
              onClick={() => +handleFloat(Profitability) >= 0 && handleSubmit()}
            ></div> */}

            <div
              className={`continue wizard-button`}
              onClick={() => handleSubmit()}
            >
              Submit
            </div>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default MenuModal;
